import React from "react";

import {
    Grid
} from "@mui/material";

import KnowledgeCard from "./KnowledgeCard";
import EmptyState from "./EmptyState";

export default function KnowledgeGrid({ items }) {

    if (!items || items.length === 0) {

        return <EmptyState />;

    }

    return (

        <Grid container spacing={3}>

            {items.map(item => (

                <Grid
                    item
                    xs={12}
                    sm={6}
                    md={4}
                    lg={3}
                    key={item.id}
                >

                    <KnowledgeCard
                        item={item}
                    />

                </Grid>

            ))}

        </Grid>

    );

}